import React from 'react';
import { Modal } from 'semantic-ui-react';
import styled from 'styled-components';
import {Avatar, Tooltip} from 'antd';
import international from '../../assets/badges/international.svg';
import nonTrad from '../../assets/badges/non-trad.svg';
import gabaPremium from '../../assets/badges/GABApremium.svg';
import gabanator from '../../assets/badges/GABAnator.svg';





export default function BadgesImages(props) {

   // console.log('badge', props.user)
   const {applicant_replicant, membership} = props.user
  

  return (

    <>
    {membership.type ==='GABAnator'?
    <Tooltip title="GABAnator" placement="top">
    <Avatar
      
      style={{
        
        backgroundColor: '#7280DA',
      }}
      src={gabanator}
    />
  </Tooltip>:null}

  {membership.type !=='GABAnator'&& membership.type !=='free'?<Tooltip title="GABA Member" placement="top">
    <Avatar
    
      style={{
         
        backgroundColor: '#7280DA',
      }}
      src={gabaPremium}
    />
  </Tooltip>:null
}

  {applicant_replicant?.includes('International') ? <Tooltip title="International Student" placement="top">
    <Avatar
      style={{
        backgroundColor: '#7280DA',
      }}
      src={international}
    />
  </Tooltip>:null}

  {applicant_replicant?.includes('Non-traditional')? <Tooltip title="Non Traditional Student" placement="top">
    <Avatar
      style={{
        backgroundColor: '#7280DA',
      }}
      src={nonTrad}
    />
  </Tooltip>:null}


  </>
   //<Avatar.Group>
   
    //{ avatarList(props.user) }

  // </Avatar.Group>
    
    
  )
}

// const ModalCont = styled(Modal)`
//   .modal-w {
//     width: 70%;
//     max-width: 800px;
//   }
  
//   @media (max-width: 768px) {
//     .modal-w {
//       width: 97%;
//     }
//   }
// `;

// const ModalBody = styled.div`
//   width: 100%;
//   text-align:center;
//   padding: 20px 16%;
//   background:transparent;  
// `;